import React, { useContext, useEffect } from "react";
import 'bootstrap/dist/css/bootstrap.min.css';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Card from 'react-bootstrap/Card';
import Accordion from 'react-bootstrap/Accordion';
import { useAccordionToggle } from 'react-bootstrap/AccordionToggle';
import AccordionContext from 'react-bootstrap/AccordionContext';
import styled from "@emotion/styled";
import {css} from "@emotion/core";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowAltCircleRight } from '@fortawesome/free-solid-svg-icons';
import { faArrowAltCircleDown } from '@fortawesome/free-solid-svg-icons';
import { faCheck } from '@fortawesome/free-solid-svg-icons'

const SectionBackground = styled.div`
  background-color : ${props => props.theme.colors.white};
  color : ${props => props.theme.colors.gray_dark};
  padding-bottom:50px;
`

const CardBody = styled(Card.Body)`
  font: 20px/22px Roboto;
`

const AccordionSubtitle = styled.div`
  font: 28px/32px Abril Fatface;
  color : ${props => props.theme.colors.gray_dark};
`

const AccordionTitleContent = styled.div`
  font: 20px/22px Roboto;
  margin-top: 10px;
  margin-bottom: 20px;
`

const CardAccordion = styled(Card)`
  border: 2px solid ${props => props.theme.colors.gray_border};
  border-left:none;
  border-right:none;
  .card-header {
    padding:0;
    background-color: ${props => props.theme.colors.white};
    border-bottom:none;
  }
  .card-body {
    text-align: justify;
    padding-left:5px;
    padding-top:0;
    padding-bottom:15px;
    span {
      margin-left:15px;
    }
    div {
      margin-top:10px;
    }
  }
  .row-video {
    img {
      width:122px;
      height:70px;
      object-fit:contain;
    }
  }
  .col-video{
    @media(min-width:1200px) {
      padding-right:0;
    }
  }
`
const FAArrow = styled(FontAwesomeIcon)`
  font-size:1.5rem;
  color: ${props => props.theme.colors.primary_violet};
  &:hover, &:focus, &.focus, &:active, &.active {
    color: ${props => props.theme.colors.primary_violet_dark};
  }
`

const FACheck = styled(FontAwesomeIcon)`
  font-size:1rem;
  color: ${props => props.theme.colors.secondary_green10};
`

function ContextAwareToggle({ children, eventKey, callback }) {
  const currentEventKey = useContext(AccordionContext);

  const decoratedOnClick = useAccordionToggle(eventKey, () =>
    callback && callback(eventKey),
  );

  const isCurrentEventKey = currentEventKey === eventKey;

  return (
    <div
      css={css`
        font: Bold 20px/28px Roboto;
        outline:none;
        padding-top:30px;
        padding-bottom:30px};
        @media(max-width:767px){
          padding-top:15px;
          padding-bottom:15px};
        }
      `}
      onClick={decoratedOnClick}
      onKeyDown={decoratedOnClick}
      role="button"
      tabIndex={0}
    >
      <Row>
        <Col xs="10" md="11">
          {children}
        </Col>
        <Col xs="2" md="1" className="d-flex justify-content-end">
          <FAArrow icon={isCurrentEventKey ? faArrowAltCircleDown : faArrowAltCircleRight} />
        </Col>
      </Row>
    </div>
  );
}

export default function FaqSection8() {
  let activeKey = "0";

  if (typeof window !== `undefined`) {  
    let params = new URLSearchParams(document.location.search);
    let getactiveKey = params.get("defaultActiveKey");
    console.log("activekey:", activeKey);
    if (getactiveKey!==null){
      activeKey = getactiveKey;
    }
  }
useEffect(() => {
  if (typeof window !== `undefined`) {
  
  let params = new URLSearchParams(document.location.search);
  let getanchorid = params.get("id");
    
    if (getanchorid != null){
      let anchorid = getanchorid;
      console.log("anchorid:", anchorid);
      let ref = document.getElementById(anchorid);
      ref.scrollIntoView({
        behavior:'smooth',
        block:'center',
        inline:'center'
      });
      console.log("scrolling");
  }
}
});
  return (      
    <SectionBackground>
      <Container>
        <Row>
          <Col lg="12">
          <Accordion defaultActiveKey={activeKey} css={css`margin-bottom:25px;`}>
            {/* <AccordionTitle>1:1 Mentorship</AccordionTitle> */}
            <AccordionSubtitle>1:1 Mentorship</AccordionSubtitle>
            <AccordionTitleContent>Our 1:1 mentorship connects one mentee and one mentor each to allow a learning experience tailored to their specific needs. From the mentor choice, number of sessions, to the curriculum and content, build a unique 1:1 mentorship experience based on your personal plans!</AccordionTitleContent>
            <CardAccordion id="section8-point1">
              <Card.Header>
                <ContextAwareToggle eventKey="0">1. Who is a mentorship best for?</ContextAwareToggle>
              </Card.Header>
              <Accordion.Collapse eventKey="0">
                <CardBody>
                <Col>
                    <Row>
                        <Col xs="auto" css={css`padding-right:0;`}>
                            <FACheck icon={faCheck} />
                        </Col>
                        <Col css={css`padding-left:7px;font: 20px/22px Roboto;`}>
                            mentees who seek greater flexibility and personalization
                        </Col>
                    </Row>
                    <Row >
                        <Col xs="auto" css={css`padding-right:0;`}>
                            <FACheck icon={faCheck} />
                        </Col>
                        <Col css={css`padding-left:7px;font: 20px/22px Roboto;`}>
                            mentees who want to connect individually with their dream mentor
                        </Col>
                    </Row>
                    <Row >
                        <Col xs="auto" css={css`padding-right:0;`}>
                            <FACheck icon={faCheck} />
                        </Col>
                        <Col css={css`padding-left:7px;font: 20px/22px Roboto;`}>
                            anyone who wants to get a first taste of our mentorship program!
                        </Col>
                    </Row>
                 </Col>
                </CardBody>
              </Accordion.Collapse>
            </CardAccordion>
            <CardAccordion id="section8-point2">
              <Card.Header>
                <ContextAwareToggle eventKey="1">2. How does it work?</ContextAwareToggle>
              </Card.Header>
              <Accordion.Collapse eventKey="1">
                <CardBody>
                <Col>
                    <Row>
                        <Col xs="auto" css={css`padding-right:0;`}>
                            <FACheck icon={faCheck} />
                        </Col>
                        <Col css={css`padding-left:7px;font: 20px/22px Roboto;`}>
                        Sign up, complete payment, and submit your video profile
                        </Col>
                    </Row>
                    <Row >
                        <Col xs="auto" css={css`padding-right:0;`}>
                            <FACheck icon={faCheck} />
                        </Col>
                        <Col css={css`padding-left:7px;font: 20px/22px Roboto;`}>
                        We assess your video profile and registration info to pick the most suitable mentor for your inquiries
                        </Col>
                    </Row>
                    <Row >
                        <Col xs="auto" css={css`padding-right:0;`}>
                            <FACheck icon={faCheck} />
                        </Col>
                        <Col css={css`padding-left:7px;font: 20px/22px Roboto;`}>
                        We connect you with the mentor; go through introductions and decide on a session schedule
                        </Col>
                    </Row>
                    <Row >
                        <Col xs="auto" css={css`padding-right:0;`}>
                            <FACheck icon={faCheck} />
                        </Col>
                        <Col css={css`padding-left:7px;font: 20px/22px Roboto;`}>
                        On the D-Day, you have the opportunity to consult with your mentor regarding your problems, ask questions, and learn from their experience
                        </Col>
                    </Row>
                 </Col>
                </CardBody>
              </Accordion.Collapse>
            </CardAccordion>
            <CardAccordion id="section8-point3">
              <Card.Header>
                <ContextAwareToggle eventKey="2">3. Can we choose our mentors, or will WomenWorks pick one for us?</ContextAwareToggle>
              </Card.Header>
              <Accordion.Collapse eventKey="2">
                <CardBody>
                    Both are applicable. You can list your mentor preferences or request in our sign up form. If you do not list any preferences or leave the choice to our team, we will find the best match based on the inquiries given in the video.
                </CardBody>
              </Accordion.Collapse>
            </CardAccordion>
            <CardAccordion id="section8-point4">
              <Card.Header>
                <ContextAwareToggle eventKey="3">4. If we book multiple 1:1 sessions, are we allowed to change our mentors midway?</ContextAwareToggle>
              </Card.Header>
              <Accordion.Collapse eventKey="3">
                <CardBody>
                    Yes, you can. Our 1:1 mentorship allows you to either proceed with the same mentor for all sessions, or to choose different mentors based on your needs. However, we also want to help our mentors maximize their impact, so we recommend sticking with the same mentor as much as possible. 
                </CardBody>
              </Accordion.Collapse>
            </CardAccordion>
            <CardAccordion id="section8-point5">
              <Card.Header>
                <ContextAwareToggle eventKey="4">5. When will my mentoring sessions be conducted?</ContextAwareToggle>
              </Card.Header>
              <Accordion.Collapse eventKey="4">
                <CardBody>
                    This depends on your mentor’s availability. Please arrange directly with your mentor.
                </CardBody>
              </Accordion.Collapse>
            </CardAccordion>
            <CardAccordion id="section8-point6">
              <Card.Header>
                <ContextAwareToggle eventKey="5">6. Why do I need to send a video? Can I send my CV/written profile/etc. instead?</ContextAwareToggle>
              </Card.Header>
              <Accordion.Collapse eventKey="5">
                <CardBody>
                    Your video profile will be our main reference in finding a mentor match. We will only proceed to the matching process once we have received your video profile. Our mentors also watch your video to get a glimpse of who you are and how to guide you, so please help them help you! :)
                </CardBody>
              </Accordion.Collapse>
            </CardAccordion>
            <CardAccordion id="section8-point7">
              <Card.Header>
                <ContextAwareToggle eventKey="6">7. What happens if I cannot commit immediately to a mentorship after I have paid and sent my video? Am I allowed to reserve my sessions?</ContextAwareToggle>
              </Card.Header>
              <Accordion.Collapse eventKey="6">
                <CardBody>
                We ask that mentees respect the mentor’s time and commitment to the mentorship. While mentorship bookings do not expire, no-shows and mentees getting MIA makes a negative experience for our mentors. Hence, please always let us know whenever you have any difficulties committing to a mentorship at any time. 
                <br></br><br></br>
                Our mentor allocations are ‘first come, first served’. Therefore, it is advised not to wait too long between your application and actually doing your mentorship, so you can get your desired mentor before they are allocated to another mentee :)
                </CardBody>
              </Accordion.Collapse>
            </CardAccordion>
            </Accordion>
          </Col>
        </Row>
      </Container>
    </SectionBackground>
  )
}